import { useEffect } from "react";

export default function usePolling(callback, intervalMs = 60000, deps = []) {
  useEffect(() => {
    let active = true;
    let inFlight = false;
    let timer = null;
    let nextDelayMs = intervalMs;

    async function run() {
      if (!active || inFlight) return;
      if (typeof document !== "undefined" && document.hidden) {
        schedule(intervalMs);
        return;
      }

      inFlight = true;
      try {
        await callback();
        nextDelayMs = intervalMs;
      } catch (err) {
        const status = Number(err?.response?.status || 0);
        if (status === 429) {
          nextDelayMs = Math.max(intervalMs * 3, 120000);
        } else {
          nextDelayMs = Math.max(intervalMs, 60000);
        }
      } finally {
        inFlight = false;
        schedule(nextDelayMs);
      }
    }

    function schedule(delay) {
      if (!active) return;
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(run, delay);
    }

    run();

    return () => {
      active = false;
      if (timer) window.clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
